import type { StoreActionApi } from 'react-sweet-state';

import type { LayoutPath, State } from '../types';

export const clearAllSelections =
    () =>
    ({ setState }: StoreActionApi<State>) => {
        setState({
            events: {
                hovered: undefined,
                selected: undefined,
                sectionPickerId: undefined,
            },
        });
    };

export const markSelected =
    (dataId: string, path: LayoutPath[]) =>
    ({ getState, setState }: StoreActionApi<State>) => {
        const currentState = getState();

        setState({
            ...currentState,
            events: {
                ...currentState.events,
                sectionPickerId: undefined,
                selected: { dataId, path },
            },
        });
    };

export const markHovered =
    (dataId: string | undefined) =>
    ({ getState, setState }: StoreActionApi<State>) => {
        const currentState = getState();

        setState({
            ...currentState,
            events: {
                ...currentState.events,
                hovered: dataId,
            },
        });
    };

export const markDragged =
    (dataId: string | undefined) =>
    ({ getState, setState }: StoreActionApi<State>) => {
        const currentState = getState();

        setState({
            ...currentState,
            events: {
                ...currentState.events,
                sectionPickerId: undefined,
                dragged: dataId,
            },
        });
    };

export const markSectionDialogOpen =
    (sectionId: string | undefined) =>
    ({ getState, setState }: StoreActionApi<State>) => {
        const currentState = getState();

        setState({
            ...currentState,
            events: {
                hovered: undefined,
                selected: undefined,
                sectionPickerId: sectionId,
            },
        });
    };

export const markIsPublishing =
    (isPublishing: boolean) =>
    ({ setState }: StoreActionApi<State>) => {
        setState({
            isPublishing,
        });
    };

export const markIsPublishDisabled =
    (isPublishDisabled: boolean) =>
    ({ setState }: StoreActionApi<State>) => {
        setState({
            isPublishDisabled,
        });
    };

export const markIsDirty =
    (isDirty: boolean) =>
    ({ setState }: StoreActionApi<State>) => {
        setState({
            isDirty,
        });
    };

export const markBrandingPreviewMode =
    (isPageInBrandingPreviewMode: boolean) =>
    ({ setState, getState }: StoreActionApi<State>) => {
        const currentState = getState();
        setState({
            ...currentState,
            isPageInBrandingPreviewMode,
        });
    };

export const setLayoutId =
    (sectionId: string, elementId: string, typename: string) =>
    ({ setState, getState }: StoreActionApi<State>) => {
        const currentState = getState();
        setState({
            ...currentState,
            layoutIds: {
                ...currentState.layoutIds,
                [typename]: { sectionId, elementId },
            },
        });
    };

export const actions = {
    clearAllSelections,
    markSelected,
    markHovered,
    markDragged,
    markSectionDialogOpen,
    markIsPublishing,
    markIsPublishDisabled,
    markIsDirty,
    markBrandingPreviewMode,
    setLayoutId,
};

export type Actions = typeof actions;
